import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Optional, Output, Self, SimpleChanges, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl, ValidatorFn, Validators } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material';
import { KeyEventsPlugin } from '@angular/platform-browser/src/dom/events/key_events';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { QuestionnaireService } from '../services/questionnaire.service';

export interface Data {
  name: string;
}

@Component({
  selector: 'app-mat-autocomplete',
  templateUrl: './mat-autocomplete.component.html',
  styleUrls: ['./mat-autocomplete.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class MatAutocompleteComponent implements OnInit, ControlValueAccessor, OnChanges {
  obsrevableArr: Observable<Data[]>;
  @Input() data: Data[];
  @Input() placeholder = '';
  clickedOut: boolean = false;
  isOpen: boolean = false;
  submitted: boolean = false;
  inputControl: FormControl;
  @Input() attAriaLabel: any;

  @Output() public change: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('selectElement') selectElement: ElementRef;
  @ViewChild('autoCompleteInput', { read: MatAutocompleteTrigger }) autoComplete: MatAutocompleteTrigger;

  constructor(@Optional() @Self() private controlDir: NgControl,
    private changeDetectionRef: ChangeDetectorRef, private eRef: ElementRef,
    private questionnaireService: QuestionnaireService) {

    if (this.controlDir) {
      this.controlDir.valueAccessor = this;
    }
    this.inputControl = new FormControl('', this.validators);
    this.inputControl.setErrors(null);
  }
  onChange: any = () => { }

  onTouch: any = () => { }

  ngOnChanges(changes: SimpleChanges): void {
  }

  writeValue(obj: any): void {
    obj && this.inputControl.setValue(obj);
  }
  registerOnChange(fn: any): void {
    this.obsrevableArr = this.inputControl.valueChanges.pipe(
      startWith(''),
      map(value => typeof value === 'string'
        ? this.filterData(value)
        : this.data.slice()
      )
    );

    this.inputControl.valueChanges.subscribe(value => {
      if (typeof value === 'string') {
        this.changeDetectionRef.detectChanges();
        fn(value);
      } else {
        fn(value);
      }
    });
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {}

  filterData(value: string): Data[] {
    if(!value) {
       return this.data.slice();
     }
   
     const search = this.normalize(value);
     const expandedOptions = this.expandAbbreviation(search);
   
     return this.data.filter(d => {
       const name = this.normalize(d.name);
   
       // עובר על כל האפשרויות (רגיל + קיצורים)
       return expandedOptions.some(option => {
         const words = option.split(' ');
         return words.every(word => this.fuzzyMatch(name, word));
       });
     });
   }
  

  normalize(value: string): string {
    return value
      .toLowerCase()
      .replace(/["'׳״]/g, '') // כל סוגי הגרשיים
      .replace(/\s+/g, ' ')
      .trim();
  }


  expandAbbreviation(value: string): string[] {
    const map: { [key: string]: string[] } = {
      'מע': ['מרכז עסקים', 'מרכזי עסקים', 'מכרז עסקים'],
      'מ ע': ['מרכז עסקים', 'מרכזי עסקים', 'מכרז עסקים'],
      'מרכז': ['מרכז עסקים', 'מרכזי עסקים', 'מכרז עסקים'],
      'מרכזי': ['מרכז עסקים', 'מרכזי עסקים', 'מכרז עסקים']
    };
  
    return map[value] || [value];
  }


  fuzzyMatch(text: string, search: string): boolean {
    if(text.includes(search)) {
       return true;
     }
   
     let i = 0;
     let j = 0;
   
    if(i < text.length && j < search.length) {
      if(text[i] === search[j]) {
         j++;
       }
       i++;
     }
   
     return j === search.length;
   }
   
  

  ngOnInit() {
    this.questionnaireService.submitted$.subscribe(isSubmitted => {
     if(isSubmitted) {
        this.inputControl.markAsTouched();
        this.submitted = true;
       if(!this.changeDetectionRef['destroyed']) {
          this.changeDetectionRef.detectChanges();
        }
      } else {
        this.inputControl.markAsUntouched();
        this.submitted = false;
       if(!this.changeDetectionRef['destroyed']) {
          this.changeDetectionRef.detectChanges();
        }
      }
    });
  }

  onKeyUp(event: any) {
   if(event && this.autoComplete.panelOpen) {
      this.isOpen = true;
    }
  }

  clickInput() {
   if(this.autoComplete.panelOpen) {
      this.isOpen = true;
    }
  }

  onSelectionChange(event: any) {
   if(event) {
      console.log('onSelectionChange', event.option.value);
    }

   if(this.autoComplete.panelOpen) {
      this.isOpen = false;
    }
  }

  private get validators(): ValidatorFn[] {
    return [Validators.required];
  }

  @HostListener('document:click', ['$event'])
  clickout(event: any) {
   if(!this.selectElement.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/mat-autocomplete/mat-autocomplete.component.ts